import React, { useEffect, useState } from 'react';
import { adminRequestStats, adminAllRequest } from '../composables/fetchAPI';
import RequestBoxPopup from './RequestBoxPopup';

// ✅ แก้ Error TS7031: กำหนด Interface ให้ Props
interface RequestBoxProps {
  isAdmin: boolean;
  portfolios: any[]; // ✅ เพิ่มตัวนี้เข้ามารองรับข้อมูลจาก HomePage ครับ
}

const RequestBox: React.FC<RequestBoxProps> = ({ isAdmin, portfolios }) => {
  const [stats, setStats] = useState<any[]>([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchStats = async () => {
    if (!isAdmin) return;
    setIsLoading(true);
    try {
      // ✅ 1. เรียกใช้ adminAllRequest (ส่ง groupBy: 'ticker' ไปเพื่อให้ได้ aggregateResult)
      const response = await adminAllRequest({
        limit: '100',
        status: 'PENDING',
        groupBy: 'ticker' // บอก Backend ให้สรุปจำนวนรายหุ้นมาให้เลย
      });

      // ✅ 2. เจาะเข้าที่ buckets โดยตรง
      if (response && response.aggregateResult && response.aggregateResult.buckets) {
        const buckets = response.aggregateResult.buckets; // [ {key: "TWST", count: 4}, ... ]

        // ✅ 3. Map ข้อมูลให้เข้ากับ Interface เดิม (เปลี่ยน key เป็น ticker)
        const formattedStats = buckets.map((item: any) => ({
          ticker: item.key,
          count: item.count,
          lastRequest: item.lastRequest // สมมติว่า Backend ส่งเวลามาให้ด้วย (ถ้าไม่มี ต้องแก้ที่ Backend เพิ่ม)
        })).sort((a: any, b: any) => b.count - a.count); // เรียงจากมากไปน้อย

        setStats(formattedStats);
      } else {
        setStats([]);
      }
    } catch (error) {
      console.error("Fetch aggregated requests error:", error);
      setStats([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    // Refresh ทุกๆ 1 นาทีสำหรับแอดมิน
    const timer = setInterval(fetchStats, 60000);
    return () => clearInterval(timer);
  }, [isAdmin]);

  if (!isAdmin) return null;

  return (
    <div className=" bg-[var(--component-bg-color)] rounded-xl border border-white/5 overflow-hidden shadow-lg transition-all hover:border-yellow-500/20">
      {/* Header */}
      <div className="px-2 py-3 flex justify-between items-center border-b border-white/5 bg-gradient-to-r from-yellow-500/10 to-transparent">
        <div className="flex items-center gap-2">
          <span className={stats.length > 0 ? "animate-pulse" : ""}>
            {stats.length > 0 ? "🔥" : "📋"}
          </span>
          <h3 className="text-[11px] font-black text-yellow-400 uppercase tracking-tighter">
            Request จากทางบ้าน 
          </h3>
        </div>
        {/* {stats.length > 0 && ( */}
        <button
          onClick={() => setIsPopupOpen(true)}
          className="text-[10px] bg-yellow-300 text-yellow-800 hover:text-black  px-2 py-1 rounded-md transition-all"
        >
          ดูทั้งหมด
        </button>
        {/* )} */}
      </div>

      {/* Mini List / Empty State */}
      <div className="p-3 flex flex-col items-center justify-center min-h-[60px]">
        {stats.length > 0 ? (
          <div className="flex flex-nowrap items-center gap-2 w-full custom-scrollbar overflow-x-auto pb-1">
            {/* 
          flex-nowrap: บังคับบรรทัดเดียว
          overflow-x-auto: เปิดให้เลื่อนขวา
          pb-1: เพิ่มพื้นที่ด้านล่างเล็กน้อยกัน scrollbar บัง (กรณี browser แสดง)
      */}
            {stats.slice(0, 8).map((item: any) => (
              <div
                key={item.ticker}
                className="shrink-0 px-2 py-1 bg-black/40 rounded-lg border border-white/5 flex items-center gap-1.5 cursor-pointer hover:bg-black/60 transition-all"
                onClick={() => window.open(`/?symbol=${item.ticker}`, '_blank')}

              >
                {/* shrink-0: สำคัญมาก กันไม่ให้ไอเทมโดนบีบจนเล็ก */}
                <span className="text-[11px] font-bold text-[var(--yellow-text-color)] whitespace-nowrap">
                  {item.ticker}
                </span>
                <span className="text-[10px] text-red-400 font-black">
                  {item.count}
                </span>
              </div>
            ))}

            {stats.length > 8 && (
              <button
                onClick={() => setIsPopupOpen(true)}
                className="shrink-0 text-[10px] text-gray-500 hover:text-yellow-400 font-medium whitespace-nowrap px-2"
              >
                +{stats.length - 8} more...
              </button>
            )}
          </div>
        ) : (
          /* ✅ ส่วนที่แสดงเมื่อไม่มีข้อมูล (เหมือนเดิม) */
          <div className="flex flex-col items-center justify-center min-h-[40px] opacity-40">
            <span className="text-[10px] font-medium text-gray-400">ยังไม่มีคำขอแนวรับ-ต้าน</span>
          </div>
        )}
      </div>

      <RequestBoxPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        fullStats={stats}
      />
    </div>
  );
};

export default RequestBox;